// extracted by mini-css-extract-plugin
export default {"table":"TopApplicators_table__6iN1R","row":"TopApplicators_row__esd1s","typeMenu":"TopApplicators_typeMenu__4Hhg6"};